<template>
    <div>
        <el-form :model="vo" @submit.native.prevent>
            <div style="width:100%;" class="el-table el-table--fit " :class="{ 'el-table--border': dataType }">
                <div class="el-table__body-wrapper">
                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__body ">
                        <tbody>
                            <tr>
                                <td ref="tdlbl_工号" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'employeeNo'" class="field">工号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <template v-if="canEdit">
                                        <el-input v-model="vo.employeeNo" placeholder="请输入工号" name="employeeNo"
                                            :maxlength="10" />
                                    </template>
                                    <template v-else>
                                        {{ vo.employeeNo }}
                                    </template>
                                    <!-- <form-item ref="employeeNo"
                                        :field="{ 'defaultValue': null, 'elementCanEdit': '{${canEdit}}', 'elementCssHeight': null, 'elementCssWidth': null, 'elementFormatter': null, 'elementReadonly': 0, 'elementType': 'input', 'emptyMessage': '请输入工号', 'errorMessage': null, 'formTdAlign': 'text-left', 'formTdColspan': 0, 'isRequired': 0, 'onClickEvent': null, 'passenger': {}, 'propComment': '工号', 'propName': 'employeeNo', 'propType': 'String', 'textFormatter': 'textfield', 'valueMaxLength': 10, 'valueMinLength': null, 'model': 'vo.employeeNo', 'option': [] }"
                                        :vo="vo" :can-edit="canEdit" /> -->
                                </td>
                                <td ref="tdlbl_入职日期" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'entryDate'" class="field">入职日期</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="entryDate"
                                        :field="{ 'defaultValue': null, 'elementCanEdit': '{${canEdit}}', 'elementCssHeight': null, 'elementCssWidth': null, 'elementFormatter': '', 'elementReadonly': 1, 'elementType': 'date', 'emptyMessage': '请选择', 'errorMessage': null, 'isRequired': 0, 'onClickEvent': null, 'passenger': {}, 'propComment': '入职日期', 'propName': 'entryDate', 'propType': 'java.util.Date', 'textFormatter': 'yyyy-MM-dd', 'valueMaxLength': null, 'valueMinLength': null, 'tbFieldName': 'entrydate', 'iconName': 'sjxzk', 'model': 'vo.entryDate', 'option': [], 'formTdAlign': 'text-left', 'weekday': 0 }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_转正日期" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'conversionDate'" class="field">转正日期</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="conversionDate"
                                        :field="{ 'defaultValue': null, 'elementCanEdit': '{${canEdit}}', 'elementCssHeight': null, 'elementCssWidth': null, 'elementFormatter': '', 'elementReadonly': 1, 'elementType': 'date', 'emptyMessage': '请选择', 'errorMessage': null, 'isRequired': 0, 'onClickEvent': null, 'passenger': {}, 'propComment': '转正日期', 'propName': 'conversionDate', 'propType': 'java.util.Date', 'textFormatter': 'yyyy-MM-dd', 'valueMaxLength': null, 'valueMinLength': null, 'tbFieldName': 'conversiondate', 'iconName': 'sjxzk', 'model': 'vo.conversionDate', 'option': [], 'formTdAlign': 'text-left', 'weekday': 0 }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_部门" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'department'" class="field">部门</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="department"
                                        :field="{ 'defaultValue': null, 'elementCanEdit': '{${canEdit}}', 'elementCssHeight': null, 'elementCssWidth': null, 'elementFormatter': null, 'elementReadonly': 1, 'elementType': 'input', 'emptyMessage': '请选择部门', 'errorMessage': null, 'formTdAlign': 'text-left', 'formTdColspan': 0, 'isRequired': 0, 'onClickEvent': '@click=\'selectStaff\'', 'passenger': {}, 'propComment': '部门', 'propName': 'department', 'propType': 'String', 'textFormatter': 'textfield', 'valueMaxLength': 100, 'valueMinLength': null, 'model': 'vo.department', 'option': [], 'autocomplete': 'off', 'dialog': 1, 'dialogType': 'custom', 'dialogOrgLevel': '', 'showWordLimit': false }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>

                                <td ref="tdlbl_工作方式" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'workNature'" class="field">工作方式</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="workNature"
                                        :field="{ 'defaultValue': null, 'elementCanEdit': '{{canEdit}}', 'elementCssHeight': null, 'elementCssWidth': null, 'elementFormatter': '1：借调\n2：外派', 'elementReadonly': null, 'elementType': 'radio', 'emptyMessage': '请选择工作方式', 'errorMessage': null, 'formTdAlign': 'text-left', 'formTdColspan': 0, 'isRequired': 0, 'onClickEvent': null, 'passenger': {}, 'propComment': '工作方式', 'propName': 'workNature', 'propType': 'String', 'textFormatter': null, 'valueMaxLength': 50, 'valueMinLength': null, 'model': 'vo.workNature', 'option': [{ 'value': '1', 'name': '借调' }, { 'value': '2', 'name': '外派' }] }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_借调/外派日期" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'secondmentDate'" class="field">借调/外派日期</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item ref="secondmentDate"
                                        :field="{ 'defaultValue': null, 'elementCanEdit': '{${canEdit}}', 'elementCssHeight': null, 'elementCssWidth': null, 'elementFormatter': '', 'elementReadonly': 1, 'elementType': 'date', 'emptyMessage': '', 'errorMessage': null, 'isRequired': 0, 'onClickEvent': null, 'passenger': {}, 'propComment': '借调/外派日期', 'propName': 'secondmentDate', 'propType': 'java.util.Date', 'textFormatter': 'yyyy-MM-dd', 'valueMaxLength': null, 'valueMinLength': null, 'tbFieldName': 'secondmentdate', 'iconName': 'sjxzk', 'model': 'vo.secondmentDate', 'option': [], 'formTdAlign': 'text-left', 'weekday': 0 }"
                                        :vo="vo" :can-edit="canEdit" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <SelectTreeDialog />
        </el-form>
        <!-- 动态新增 -->
        <div v-for="(item, index) in vo.passenger.appointmnetInfos" :key="item.id" class="appointmnetInfosList">
            <div class="rz_title">
                <span>任职信息{{ convertToChineseNumber(index + 1) }}</span>
                <span>
                    <el-link v-if="canEdit" type="danger" size="small" icon="el-icon-delete"
                        @click="delAppointmnetInfo(item)">删除</el-link>
                </span>
            </div>
            <el-form :model="item" @submit.native.prevent>
                <div style="width: 100%;" :style="{ 'border-top': dataType ? '' : '1px solid #999' }"
                    class="el-table el-table--fit" :class="{ 'el-table--border': dataType }">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                            <tbody>
                                <tr>
                                    <td ref="tdlbl_部门" class="el-table__cell tdlbl tdw13" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'department'" class="field">部门</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw20" colspan="1">
                                        <div v-if="canEdit">
                                            <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="部门"
                                                :rules="departmentRules">
                                                <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]"
                                                    :class="{ 'invalid-field': errors[0] !== undefined }"
                                                    popper-class="error-popper-class" placement="right-start"
                                                    effect="dark">
                                                    <!-- :root-org-code="vo.orgCode" -->
                                                    <el-input v-model="item.department" v-select-dialog="'suborg'"
                                                        org-level="2,3,4" dialog-title="选择部门" multiple="false"
                                                        :row-index="index" placeholder="请选择部门" name="department" />

                                                    <!-- <el-input v-model="item.department" placeholder="请选择部门" class="input-with-select">
                                                        <el-button slot="append" icon="el-icon-more" @click="selectSuborg(item, index, '选择部门', 'department')"></el-button>
                                                    </el-input> -->
                                                </el-tooltip>
                                            </ValidationProvider>
                                        </div>
                                        <div v-else>{{ item.department }}</div>
                                    </td>
                                    <td ref="tdlbl_职务  " class="el-table__cell tdlbl tdw13" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'post'" class="field">职务</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw20" colspan="1">
                                        <!-- 选择数据列表 -->
                                        <div v-if="canEdit">
                                            <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="职务"
                                                :rules="postRules">
                                                <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]"
                                                    :class="{ 'invalid-field': errors[0] !== undefined }"
                                                    popper-class="error-popper-class" placement="right-start"
                                                    effect="dark">
                                                    <!-- <el-input v-model="item.post" v-can-edit v-listpage-dialog :can-edit="editEmploy" listviewurl="rsgl.config.list_zw?urlsearch=status:1" dialog-title="选择职务" :multiple="false" :index="index" placeholder="请选择职务" name="post" exclude-fields="status,blankPlace" retain-btns="" /> -->
                                                    <el-input v-model="item.post" :can-edit="canEdit" :index="index"
                                                        placeholder="请选择职务" name="post"
                                                        exclude-fields="status,blankPlace" retain-btns="" />
                                                </el-tooltip>
                                            </ValidationProvider>
                                        </div>
                                        <div v-else>{{ item.post }}</div>
                                    </td>
                                    <td ref="tdlbl_编制部门" class="el-table__cell tdlbl tdw13" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'preparationDepart'" class="field">编制部门</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw20" colspan="1">
                                        <form-item ref="preparationDepart" :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '0：是\n1：否',
                                            elementReadonly: 1,
                                            elementType: 'radio',
                                            emptyMessage: '请选择编制部门',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '编制部门',
                                            propName: 'preparationDepart',
                                            propType: 'Short',
                                            textFormatter: null,
                                            valueMaxLength: 10,
                                            valueMinLength: null,
                                            model: 'item.preparationDepart',
                                            option: [
                                                { value: '0', name: '是' },
                                                { value: '1', name: '否' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: true,
                                            filterable: false,
                                            allowCreate: false
                                        }" :vo="item" :can-edit="canEdit" />
                                    </td>
                                </tr>
                                <tr>
                                    <td ref="tdlbl_排序编号" class="el-table__cell tdlbl tdw13" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'sortNumber'" class="field">排序编号</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw100" colspan="5">
                                        <div v-if="canEdit">
                                            <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="职务"
                                                :rules="{ required: true }">
                                                <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]"
                                                    :class="{ 'invalid-field': errors[0] !== undefined }"
                                                    popper-class="error-popper-class" placement="right-start"
                                                    effect="dark">
                                                    <el-input v-model="item.sortNumber" placeholder="请输入排序编号"
                                                        name="post" />
                                                </el-tooltip>
                                            </ValidationProvider>
                                        </div>
                                        <div v-else>{{ item.sortNumber }}</div>
                                        <!-- <form-item ref="sortNumber"
                                            :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入排序编号', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '排序编号', propName: 'sortNumber', propType: 'String', textFormatter: 'textfield', valueMaxLength: 10, valueMinLength: null, model: 'item.sortNumber', option: [], autocomplete: 'off', showWordLimit: false }"
                                            :vo="item" :can-edit="canEdit" /> -->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
        </div>
        <div v-if="canEdit" class="addappointmnetInfo">
            <el-link type="primary" size="small" icon="el-icon-plus" @click="addAppointmnetInfo">添加任职信息</el-link>
            <!-- <el-link type="primary" size="small" icon="el-icon-plus" @click="addAppointmnetInfo"></el-link> -->
        </div>
        <div style="width:100%;padding:20px 0;bottom:10px;text-align:center;display:flex;justify-content:center;">
            <el-button v-if="canEdit == 1" type="" @click="canEdit = 0">取消</el-button>
            <el-button v-if="canEdit == 1" type="primary" :loading="doing" @click="handleSubmit">提交</el-button>
            <el-button v-if="canEdit == 0" type="primary" @click="canEdit = 1">修改</el-button>
        </div>
    </div>
</template>
<script>
import SelectTreeDialog from './SelectTreeDialog.vue'
export default {
    components: {
        SelectTreeDialog
    },
    props: {
        vo: { type: Object, default: function () { return {} } },
        dataType: { type: String, default: '' },
        moduleInfo: { type: Object, default: function () { return {} } }
    },
    setup() {
        const postRules = {
            required: true
        }
        const departmentRules = {
            required: true
        }
        const postRankRules = {
            required: true
        }

        return {
            postRules, // 职务
            departmentRules, // 部门
            postRankRules // 职级
        }
    },
    data: function () {
        return {
            loginUser: this.$store.getters.loginUser,
            openSysCode: 'mmjsxy_ecyoa',
            canEdit: 0
        }
    },
    computed: {
    },
    created: function () {
        if (!this.vo.passenger.appointmnetInfos || this.vo.passenger.appointmnetInfos.length === 0) {
            this.$set(this.vo.passenger, 'appointmnetInfos', [])
        }
        // if (this.canEdit) {
        //     let isAdmin = this.$store.state.user.roles.includes('dwAdministrators')
        //     if (isAdmin) {
        //         this.editEmploy = 1
        //     }
        // }
        console.log('loginUser', this.loginUser)
    },
    methods: {
        selectStaff(row, index, dialogTitle) {
            // this.selectRow = row
            const el = {
                dialogTitle: '选择部门',
                index,
                multiple: false,
                attrs: { 'dialog-title': '选择部门', 'root-org-code': this.loginUser.orgCode, 'org-level': '2,3,4', 'row-index': 'index', name: 'department' },
                value: ''
            }
            const vnode = {
                context: this,
                data: {
                    model: { expression: 'selectDialog' },
                    attrs: {}
                }
            }

            this.$bus.emit('RsglOpenSelectDialog', el, { value: 'suborg' }, vnode)
        },
        // onSelectSuborgCompleted(selectedNodes, attr) {
        //     this.$set(this.vo, 'department', selectedNodes[0].name)
        //     this.$set(this.vo, 'orgFullId', selectedNodes[0].orgFullId)
        // },
        // 选择部门
        onSelectSuborgCompleted: function (selectedRows, attr) {
            // debugger
            console.log('attr', attr)

            if (attr['row-index'] === 'index') {
                this.$set(this.vo, 'department', selectedRows[0].name)
                this.$set(this.vo, 'orgFullId', selectedRows[0].orgFullId)
            } else {
                this.$set(this.vo.passenger.appointmnetInfos[attr['row-index']], 'department', selectedRows[0].name)
                this.$set(this.vo.passenger.appointmnetInfos[attr['row-index']], 'orgFullId', selectedRows[0].orgFullId)
            }
        },
        // 选择数据列表
        onSelectListpageRowCompleted: function (selectedRows, attr) {
            if (attr.name === 'post') {
                this.$set(this.vo.passenger.appointmnetInfos[attr['row-index']], 'post', selectedRows[0].postName)
            } else if (attr.name === 'postRank') {
                this.$set(this.vo.passenger.appointmnetInfos[attr['row-index']], 'postRank', selectedRows[0].rankName)
            }
        },
        addAppointmnetInfo() {
            // 新增任职信息
            // appointmnetInfo
            this.$http({
                method: 'POST',
                url: '/rsgl/appointmnetInfo/addNew'
            }).then((res) => {
                if (res.code === 'success') {
                    this.vo.passenger.appointmnetInfos.push(res.body.vo)
                    console.log('this.vo', this.vo)
                }
            })
        },
        delAppointmnetInfo(row) {
            this.$confirm('是否确定删除该记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.vo.passenger.appointmnetInfos = this.vo.passenger.appointmnetInfos.filter((item) => item.id !== row.id)
                })
                .catch(() => { })
        },
        convertToChineseNumber(num) {
            const chineseDigits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
            const tens = ['', '十', '二十', '三十', '四十', '五十', '六十', '七十', '八十', '九十']

            if (num === 0) {
                return chineseDigits[0]
            }

            const units = num % 10
            const tensPart = Math.floor(num / 10) * 10

            let result = ''

            if (tensPart > 0) {
                result += tens[tensPart / 10]
            }

            if (units > 0) {
                result += chineseDigits[units]
            }

            // 处理10-19的特殊情况
            if (result.endsWith('十') && units !== 0) {
                result = result.slice(0, -1) + tens[units]
            }

            // 去除开头的零（例如05转换为五而不是零五）
            return result.replace(/^零+/, '')
        },
        handleSubmit() {
            this.formValidate(() => {
                this.$emit('handleSubmit', (isSuccess) => {
                    if (isSuccess) this.canEdit = 0
                })
            }, null, 1)
        }
    }

}

</script>

<style scoped lang="scss">
.rz_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: var(--portalFontSize14);
    margin: 15px 0;
    padding: 0 10px;

}

.addappointmnetInfo {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 15px 0;
}

.appointmnetInfos .el-table .el-table__body-wrapper .el-table__body .tdlbl {
    background: #F2F5FB !important;
    padding: 4px 6px 4px 15px;

    .required {
        margin-right: 3px;
    }
}
</style>
